import { render, staticRenderFns } from "./SimpleModuleDashboard.vue?vue&type=template&id=c71729f2&"
import script from "./SimpleModuleDashboard.vue?vue&type=script&lang=js&"
export * from "./SimpleModuleDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleModuleDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports